
$(document).ready(function () {
 // Enable checkboxes after page load
 $("input[type='checkbox']").prop("disabled", false);
 // Scroll to top on page unload
 $(window).on("beforeunload", function () {
   $(window).scrollTop(0);
 });
 // Show/Hide header tabs
 $(".tab").click(function () {
   let tabId = $(this).attr("data-id");
   $(".tab-content").removeClass("active-tab-content");
   $(`.tab-content[data-id='${tabId}']`).addClass("active-tab-content");
   $(".tab").removeClass("active-tab");
   $(this).addClass("active-tab");
   $("#searchbar").val("").trigger("keyup");
   $("html, body").animate({ scrollTop: 0 }, 500, "swing");
 });


 // Sticky header on scroll
 $(window).scroll(function () {
   let height = $(window).height();
   let scroll = $(window).scrollTop();
   $(".sticky-header").toggleClass("show", scroll > height);
 });

 function imageUpdate(tabId) {
      let $imageList = $(`#tab_images li img`);
      $imageList.attr("src", "");
      let index = 0;

      $("#flexi-box-form")
      .find(".product-checkbox:checked")
      .each(function () {
         let imgUrl = $(this).data("img");
         let qty = parseInt($(this).closest(".product-info").find(".quantity-input").val() || 1);

         // Repeat image based on quantity
         for (let i = 0; i < qty; i++) {
            if (index < $imageList.length) {
               $imageList.eq(index).attr("src", imgUrl);
               index++;
            }
         }
      });
   }

function bundleCreate() {
  let items = 1;
  let totalPrice = 0;
  let bundlePrice = parseInt($("#flexi-box-form").attr("data-price"));

  // Remove previous hidden inputs
  $("#flexi-box-form input[name^='properties[_bundle_product']").not("[name*='_bundle_productX']").remove();

  // Calculate total price
  $("#flexi-box-form .product-checkbox:checked").each(function () {
    let quantity = parseInt($(this).closest(".product-info").find(".quantity-input").val()) || 1;
    let bundleParts = $(this).attr("data-bundle").split("/");
    totalPrice += parseFloat(bundleParts[1]) * quantity;
  });

  // Prevent divide-by-zero
  if (totalPrice <= 0) {
    // alert("Please select at least one product before submitting.");
    return;
  }

  // Handle selected products
  $("#flexi-box-form .product-checkbox:checked").each(function () {
    let $checkbox = $(this);
    let productValue = $checkbox.val();
    let productName = $checkbox.attr("name") || "";

    // Skip invalid/hidden
    if (
      !productValue ||
      productValue.toLowerCase() === "no" ||
      productValue.toLowerCase().includes("hidden") ||
      productName.toLowerCase().includes("hidden")
    ) {
      $checkbox.prop("disabled", true);
      return;
    }

    let bundle = $checkbox.attr("data-bundle");
    let quantity = parseInt($checkbox.closest(".product-info").find(".quantity-input").val()) || 1;

    // Save original value
    let originalValue = $checkbox.attr("data-original-value") || productValue.split(" (Qty:")[0];
    $checkbox.attr("data-original-value", originalValue);

    // Set product property with qty
    let productProperty = originalValue;
    if (quantity > 1) productProperty += ` (Qty: ${quantity})`;

    $checkbox.attr("name", "properties[ITEM" + items + "]");
    $checkbox.val(productProperty);

    // Update bundle price proportionally
    let bundleParts = bundle.split("/");
    let update_price;

    if (quantity > 1) {
      update_price = ((parseFloat(bundleParts[1]) * quantity) / totalPrice) * bundlePrice;
      bundleParts[1] = Math.round(update_price);
      bundleParts[2] = quantity;
    } else {
      update_price = (parseFloat(bundleParts[1]) / totalPrice) * bundlePrice;
      bundleParts[1] = Math.round(update_price);
    }

    bundle = bundleParts.join("/");
    console.log("Bundle:", bundle);

    // Append hidden input
    $("<input>")
      .attr("type", "hidden")
      .attr("name", "properties[_bundle_product" + items + "]")
      .val(bundle)
      .appendTo("#flexi-box-form");

    items++;
  });
}

 // Passing line-items on clicking submit button
 $("#submit-btn").click(function (e) {

  // ✅ Submit the form
  $(this).submit();

  // Reset after short delay
  setTimeout(function () {
    $("#flexi-box-form").trigger("reset");
    $("#flexi-box-form .quantity-selector").hide();
    $("#flexi-box-form #submit-btn").hide();
    $("#flexi-box-form .product_counter").addClass("_hidden");
    $("#flexi-box-form svg.added_to_cart").addClass("_hidden");
    $("#flexi-box-form .product-checkbox").prop("disabled", false);
  }, 900);
});

 let checkboxes = $("input[type='checkbox']");

 // Quantity selector functionality
 function updateQuantity(input, change) {
   let currentVal = parseInt(input.val()) || 1;
   let newVal = currentVal + change;
   let maxVal = parseInt(input.attr("max")) || 999;
   let minVal = parseInt(input.attr("min")) || 1;

   if (newVal >= minVal && newVal <= maxVal) {
     input.val(newVal);
     input.closest(".product-info").find(".product_counter").text(newVal);
   }
 }

 function getTotalSelectedQuantityInTab(tabId) {
   let total = 0;
   $(`[data-id="tab${tabId}"] .product-checkbox:checked`).each(function () {
     let quantity =
       parseInt($(this).closest(".product-info").find(".quantity-input").val()) || 1;
     total += quantity;
   });
   return total;
 }

 function updateTabCounts(tabId) {
   let totalSelected = getTotalSelectedQuantityInTab(tabId);
   let $tabContent = $(`.tab-content[data-id="tab${tabId}"]`);
   let selectionLimit = parseInt($tabContent.attr("data-product-limit"));
   let currProductDataId = "tab_" + tabId + "_product";

  imageUpdate(tabId);

   if (totalSelected === selectionLimit) {
     $(`#checkbox_count_${currProductDataId}`)
       .css("display", "inline-block")
       .html(`&#10004;`);
       bundleCreate();
       $tabContent.find(".product-checkbox:not(:checked)").prop("disabled", true);
       $tabContent.find(".product-checkbox:not(:checked)").each(function () {
          $(this).closest(".add-to-box").addClass("disables");
      });
   } else if (totalSelected > 0) {
     $(`#checkbox_count_${currProductDataId}`).css("display", "inline-block").text(totalSelected);
     $tabContent.find(".product-checkbox:not(:checked)").prop("disabled", false);
    $tabContent.find(".add-to-box").removeClass("disables");
   } else {
     $(`#checkbox_count_${currProductDataId}`).css("display", "none");
     $tabContent.find(".product-checkbox:not(:checked)").prop("disabled", false);
     $tabContent.find(".add-to-box").removeClass("disables");
   }

   checkSubmitButtonVisibility();

   // Auto-switch when tab is full
   if (totalSelected === selectionLimit) {
     let nextTab = `tab${parseInt(tabId) + 1}`;
     if ($(`.tab[data-id='${nextTab}']`).length > 0) {
       setTimeout(() => {
         $(`.tab[data-id='${nextTab}']`).click();
         $("#searchbar").val("").trigger("keyup");
         $("html, body").animate({ scrollTop: 0 }, 500, "swing");
       }, 500);
     }
   }
 }

 function checkSubmitButtonVisibility() {
   
   let totalSelectedAcrossAllTabs = 0;
   $(".tab-content").each(function () {
     let tabId = $(this).attr("data-id").replace("tab", "");
     totalSelectedAcrossAllTabs += getTotalSelectedQuantityInTab(tabId);
   });
   if (totalSelectedAcrossAllTabs == totalproductSelection) {
     $("#submit-btn").css("display", "inline-block");
     confetti({ particleCount: 200, spread: 80, origin: { y: 0.6 } });
   } else {
     $("#submit-btn").css("display", "none");
   }
 }

 // Quantity + button
 $(document).on("click", ".quantity-plus", function (e) {
   e.preventDefault();
   let input = $(this).siblings(".quantity-input");
   let currTabId = parseInt(input.attr("data-tab-index"));
   let selectionLimit = parseInt(
     $(`.tab-content[data-id="tab${currTabId}"]`).attr("data-product-limit")
   );
   let totalSelectedInTab = getTotalSelectedQuantityInTab(currTabId);
   let currentQuantity = parseInt(input.val()) || 1;


   if (totalSelectedInTab - currentQuantity + (currentQuantity + 1) <= selectionLimit) {
     updateQuantity(input, 1);
     updateTabCounts(currTabId);
   }
 });


 // Quantity - button
 $(document).on("click", ".quantity-minus", function (e) {
   e.preventDefault();
   let input = $(this).siblings(".quantity-input");
   let currTabId = parseInt(input.attr("data-tab-index"));
   updateQuantity(input, -1);
   updateTabCounts(currTabId);
 });


 // Direct quantity input
 $(document).on("change", ".quantity-input", function () {
   let currTabId = parseInt($(this).attr("data-tab-index"));
   let selectionLimit = parseInt(
     $(`.tab-content[data-id="tab${currTabId}"]`).attr("data-product-limit")
   );
   let totalSelectedInTab = getTotalSelectedQuantityInTab(currTabId);


   if (totalSelectedInTab > selectionLimit) {
     $(this).val(1);
     alert("Total quantity cannot exceed the selection limit of " + selectionLimit);
   }
   updateTabCounts(currTabId);
 });

 // Checkbox click handler
 checkboxes.click(function () {
   let currProductDataId = $(this).attr("data-id-products");
   let currTabId = Number(currProductDataId.split("_")[1]);
   let selectionLimit = parseInt(
     $(`.tab-content[data-id="tab${currTabId}"]`).attr("data-product-limit")
   );

   if ($(this).is(":checked")) {
     let currentTabTotal = getTotalSelectedQuantityInTab(currTabId);
     if (currentTabTotal > selectionLimit) {
       $(this).prop("checked", false);
       alert("Selection limit of " + selectionLimit + " reached for this category");
       return;
     }

     $(this).parents(".product-info").find(".quantity-selector").show();
     $(this).parents(".product-info").find(".added_to_cart").removeClass("_hidden");
     $(this).parents(".product-info").find(".product_counter").removeClass("_hidden");
     $(this).closest(".product-info").find(".quantity-input").val(1);
     $(this).parents(".product-info").find(".product_counter").text("1");

     let productTitle = $(this).val().split(" SKU:")[0];
     $(".Message_Bar").removeClass("is-hidden");
     $(".Message_Bar p span").text(productTitle);
     setTimeout(function () {
       $(".Message_Bar").addClass("is-hidden");
       $(".Message_Bar p span").text("");
     }, 2500);
   } else {
     $(this).parents(".product-info").find(".added_to_cart").addClass("_hidden");
     $(this).parents(".product-info").find(".product_counter").addClass("_hidden");
     $(this).parents(".product-info").find(".quantity-selector").hide();
     $(this).closest(".product-info").find(".quantity-input").val(1);
     $(this).parents(".product-info").find(".product_counter").text("1");
   }
   updateTabCounts(currTabId);
 });

 // Disable right-click + F12
 $(document).bind("contextmenu", function (e) {
   e.preventDefault();
 });
 $(document).keydown(function (e) {
   if (e.which === 123) return false;
 });

 // Custom search bar
 $("#searchbar").on("keyup", function () {
   var value = $(this).val().toLowerCase();
   $("#collection-list li").filter(function () {
     $(this).toggle($(this).find("a").text().toLowerCase().indexOf(value) > -1);
   });
 });

 // Clear search
 $(".search-clear").click(function () {
   $("#searchbar").val("").trigger("keyup");
 });
}); // document.ready ends

